module.exports = __webpack_public_path__ + "assets/img/5bd4-sr.svg";